export default class Stack<T> {
  private items: T[];

  constructor() {
    this.items = [];
  }

  private setItemAt(item: T, i: number): void {
    this.items[i] = item;
  }

  private getItemAt(i: number): T | undefined {
    if (i < 0 || i >= this.items.length) throw new Error("Index out of bounds");
    return this.items[i];
  }

  push(item: T): void {
    this.items.push(item);
  }

  pop(): T | undefined {
    if (this.items.length === 0) throw new Error("Stack is empty");
    return this.items.pop();
  }

  peek(): T | undefined {
    return this.getItemAt(this.size() - 1);
  }

  isEmpty(): boolean {
    return this.size() === 0;
  }

  size(): number {
    return this.items.length;
  }

  clear(): void {
    this.items = [];
  }

  includes(item: T): boolean {
    return this.items.includes(item);
  }
}
